import React, { Component } from "react";
import Select from 'react-select';
// Usar react-date-range (compatible con React 17)
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import moment from 'moment';
import 'moment/locale/es';
import '../styles/datepicker-override.css';
import '../styles/pagination-override.css';
import ReactPaginate from 'react-paginate';
import { LangContext } from "../LangContext.jsx";
moment.locale('es');
class ReportsUsers extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            users: [],
            currentPage: 0,
            itemsPerPage: 10,
            totalPages: 0,
            showFrom: 0,
            showTo: 0,
            totalUsers: 0,
            showExport: true,
            showRut: false,
            selectedId: null,
            selectedName: null,
            selectedRole: null,
            selectedStatus: null,
            idOptions: [],
            nameOptions: [],
            emailOptions: [],
            roleOptions: [],
            statusOptions: [
                {value: "1", label: "Activo"},
                {value: "0", label: "Inactivo"},
            ],
            focusedInput: null,
            startDate: null,
            endDate: null,
            showCreatedPicker: false,
            showAdvancedFilters: false,
            params : {
                user:{
                    userId: null,
                    name: null,
                    email: null,
                    roleTitle: null,
                    status: null,
                    created_at: null
                },
                sort:{
                    order: null,
                    column: null
                },
                page: 0,
                limit:  10,
            },
        };
        this.createdPickerRef = React.createRef();
    }

    getUsers(){
        const { currentPage, itemsPerPage } = this.state;
        axios.get('/api/reports/users', {
                params: {
                    ...this.state.params,
                    page: currentPage +1,
                    limit: itemsPerPage
                }
            }).then(res=>{
                let users = res.data.data;

                this.setState({
                    users,
                    showFrom: res.data.from,
                    showTo: res.data.to,
                    totalUsers: res.data.total,
                    totalPages: Math.ceil(res.data.total / itemsPerPage)
                });
        })
        this.getFilters();
    }

    getFilters() {
        axios.get('/api/filters/users', {
            params: {
                ...this.state.params,
            }
        }).then((res) => {
            const userFilters = res.data;
            this.setState({
                idOptions: userFilters.idOptions,
                nameOptions: userFilters.nameOptions,
                emailOptions: userFilters.emailOptions,
                roleOptions: userFilters.roleOptions
            });
        });
    }

    exportReports() {
        const ids = this.state.idOptions.map(item => item.value);
        const dataJSON = JSON.stringify(ids);

        axios.post('/api/export/users', {
            data: dataJSON,
        }, {
            responseType: 'blob',
        }).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');

            const fileName = 'ReporteUsuarios.xls';
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        });
    }


    componentDidMount() {
        this.getUsers();
        document.addEventListener('mousedown', this.handleClickOutside);
    };

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleIdChange = (event) => {
        let value = (event) ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            user: {
                ...this.state.params.user,
                userId: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedId: event,
        }, this.getUsers);
    }

    handleNameChange = (event) => {
        let value = (event) ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            user: {
                ...this.state.params.user,
                name: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedName: event,
        }, this.getUsers);
    }

    handleEmailChange = (event)=>{
        const value = event ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            user: {
                ...this.state.params.user,
                email: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedEmail: event,
        }, this.getUsers);
    }

    handleRoleChange = (event)=>{
        const value = event ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            user: {
                ...this.state.params.user,
                roleTitle: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedRole: event,
        }, this.getUsers);
    }

    handleStatusChange = (event)=>{
        const value = event ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            user: {
                ...this.state.params.user,
                status: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedStatus: event,
        }, this.getUsers);
    }

    handleDateChange = (ranges) => {
        const sel = ranges.selection || {};
        const startDate = sel.startDate || null;
        const endDate = sel.endDate || null;
        const startStr = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        const endStr = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
        const updatedParams = {
            ...this.state.params,
            user: {
                ...this.state.params.user,
                created_at: { startDate: startStr, endDate: endStr }
            }
        };

        this.resetCurrentPage();
        this.setState({
            startDate: startStr,
            endDate: endStr,
            params: updatedParams
        }, this.getUsers);
    }

    toggleCreatedPicker = () => this.setState(prev => ({ showCreatedPicker: !prev.showCreatedPicker }));
    handleClickOutside = (e) => {
        if (this.state.showCreatedPicker && this.createdPickerRef.current && !this.createdPickerRef.current.contains(e.target)) {
            this.setState({ showCreatedPicker: false });
        }
    }

    handlePageClick = (data) => {
        let selected = data.selected;
        this.setState({ currentPage: selected }, this.getUsers);
    }

    handleItemsPerPageChange = (event) => {
        const newItemsPerPage = parseInt(event.target.value, 10);
        this.setState({
            itemsPerPage: newItemsPerPage,
            currentPage: 0
        }, this.getUsers);
    };

    resetCurrentPage = () => {
        this.setState({
            currentPage: 0,
        });
    }

    clearDates = () => {
        const updatedParams = {
            ...this.state.params,
            user: {
                ...this.state.params.user,
                created_at: {startDate: null, endDate: null}
            }
        };

        this.setState({
            params: updatedParams,
            startDate: null,
            endDate: null
        }, this.getUsers);
    }

    clearFilters = () => {
        this.setState({
            selectedId: null,
            selectedName: null,
            selectedEmail: null,
            selectedRole: null,
            selectedStatus: null,
            startDate: null,
            endDate: null,
            params : {
                user:{
                    userId: null,
                    name: null,
                    email: null,
                    roleTitle: null,
                    status: null,
                    created_at: null
                },
                sort:{
                    order: null,
                    column: null
                },
            },
        }, this.getUsers);
    };

    handleSort = (column) => {
        this.setState(prevState => {
            if (column === prevState.params.sort.column) {
                return {
                    params: {
                        ...prevState.params,
                        sort: {
                            ...prevState.params.sort,
                            column: column,
                            order: prevState.params.sort.order === 'asc' ? 'desc' : 'asc'
                        }
                    }
                };
            } else {
                return {
                    params: {
                        ...prevState.params,
                        sort: {
                            ...prevState.params.sort,
                            column: column,
                            order: 'asc'
                        }
                    }
                };
            }
        }, this.getUsers);
    };

    toggleAdvancedFilters = () => {
        this.setState(prevState => ({
            showAdvancedFilters: !prevState.showAdvancedFilters
        }));
    };

    render() {
        const { lang } = this.context;
      return (
        <>
            <div className="subheader py-6 py-lg-8 subheader-transparent" id="kt_subheader">
                <div className="container d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                    <div>
                        <h5 className="text-dark font-weight-bold my-1 mr-5">
                            {lang.get('messages.reporte_de_usuarios')}
                        </h5>
                        <p className="text-dark-50 font-weight-bold my-1 mr-5">
                            <span className="text-primary datatable-count">{this.state.totalUsers}</span> {lang.get('messages.usuarios')}
                        </p>
                    </div>
                    <div className="d-flex align-items-center flex-wrap">
                        {this.state.showExport &&
                            <a
                                id="export"
                                className="btn btn-primary px-10 font-weight-bolder"
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.exportReports();
                                }}
                                >{lang.get('messages.exportar')}</a>
                        }
                    </div>
                </div>
            </div>
            
            <div className="container">
                <div className="datatable-filters">
                    <div className="d-flex justify-content-between mb-4">
                        <div className="font-weight-bolder">{lang.get('messages.filtrar_por')}:</div>
                        <a
                            className="datatable-clear-filters float-right text-primary"
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                this.clearFilters();
                            }}
                        ><strong>{lang.get('messages.limpiar_todos_los_filtros')}</strong></a>
                    </div>

                    <div className="d-flex justify-content-between mb-4 default">
                        <div className="col-md-4">
                            <label className="mb-0 text-dark-50 font-weight-bold">Id</label>
                            <Select
                                value={this.state.selectedId}
                                onChange={this.handleIdChange}
                                options={this.state.idOptions}
                                placeholder={<div>{lang.get('messages.buscar_por')} Id</div>}
                                isClearable={true}
                            />
                        </div>
                        <div className="col-md-4">
                            <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.nombre')}</label>
                            <Select
                                value={this.state.selectedName}
                                onChange={this.handleNameChange}
                                options={this.state.nameOptions}
                                placeholder={<div>{lang.get('messages.buscar_por_nombre')}</div>}
                                isClearable={true}
                            />
                        </div>
                        <div className="col-md-4">
                            <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.correo')}</label>
                            <Select
                                value={this.state.selectedEmail}
                                onChange={this.handleEmailChange}
                                options={this.state.emailOptions}
                                placeholder={<div>{lang.get('messages.buscar_por_email')}</div>}
                                isClearable={true}
                            />
                        </div>
                    </div>
                    {this.state.showAdvancedFilters && (
                        <div className="advanced-filters">
                            <div className="d-flex justify-content-between mb-4 default">
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.permisos')}</label>
                                    <Select
                                        value={this.state.selectedRole}
                                        onChange={this.handleRoleChange}
                                        options={this.state.roleOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por_permisos')}</div>}
                                        isClearable={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.estatus')}</label>
                                    <Select
                                        value={this.state.selectedStatus}
                                        onChange={this.handleStatusChange}
                                        options={this.state.statusOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por_estatus')}</div>}
                                        isClearable={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <div className="datepicker-container">
                                        <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.fecha_de_creacion')}</label><br></br>
                                        <div style={{ position: 'relative' }}>
                                            <div
                                                className="form-control d-flex align-items-center justify-content-between"
                                                style={{ cursor: 'pointer' }}
                                                onClick={this.toggleCreatedPicker}
                                            >
                                                <span>{this.state.startDate ? moment(this.state.startDate).format('ll') : lang.get('messages.fecha_inicio')}</span>
                                                <span className="mx-2">–</span>
                                                <span>{this.state.endDate ? moment(this.state.endDate).format('ll') : lang.get('messages.fecha_fin')}</span>
                                                {(this.state.startDate || this.state.endDate) && (
                                                    <span onClick={(e) => { e.stopPropagation(); this.clearDates(); }} style={{ marginLeft: 'auto' }}>
                                                        <i className="flaticon2-delete text-muted"></i>
                                                    </span>
                                                )}
                                            </div>

                                            {this.state.showCreatedPicker && (
                                                <div ref={this.createdPickerRef} className="date-range-popover">
                                                    <DateRange
                                                        ranges={[{
                                                            startDate: this.state.startDate ? new Date(this.state.startDate) : new Date(),
                                                            endDate: this.state.endDate ? new Date(this.state.endDate) : new Date(),
                                                            key: 'selection'
                                                        }]}
                                                        onChange={this.handleDateChange}
                                                        editableDateInputs={true}
                                                        moveRangeOnFirstSelection={false}
                                                        months={1}
                                                        direction="horizontal"
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    )}
                    {this.state.showAdvancedFilters == false &&
                        <div className="my-4">
                            <a href="#"
                            className="text-primary font-weight-bold"
                            onClick={(e) => {
                                e.preventDefault();
                                this.toggleAdvancedFilters();
                            }}>
                                <span className="flaticon2-down mr-2"></span> Mostrar filtros avanzados
                            </a>
                        </div>
                    }
                    {this.state.showAdvancedFilters == true &&
                        <div className="my-4">
                            <a href="#"
                            className="text-primary font-weight-bold"
                            onClick={(e) => {
                                e.preventDefault();
                                this.toggleAdvancedFilters();
                            }}>
                                <span className="flaticon2-up mr-2"></span> {lang.get('messages.ocultar_filtros_avanzados')}
                            </a>
                        </div>
                    }
                </div>
                <div className="table-responsive">
                    <table className="table table-report w-100" id="datatable">
                        <thead>
                            <tr>
                                <th style={{ width: '100px' }} onClick={() => this.handleSort('userId')}>
                                    #
                                    {this.state.params.sort.column === 'userId' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '150px' }} onClick={() => this.handleSort('name')}>
                                    Nombre
                                    {this.state.params.sort.column === 'name' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '150px' }} onClick={() => this.handleSort('email')}>
                                    {lang.get('messages.correo')}
                                    {this.state.params.sort.column === 'email' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '100px' }} onClick={() => this.handleSort('roleTitle')}>
                                    {lang.get('messages.permisos')}
                                    {this.state.params.sort.column === 'roleTitle' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '100px' }} onClick={() => this.handleSort('status')}>
                                    {lang.get('messages.estatus')}
                                    {this.state.params.sort.column === 'status' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '150px' }} onClick={() => this.handleSort('created_at')}>
                                    {lang.get('messages.fecha_creacion')}
                                    {this.state.params.sort.column === 'created_at' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.users.map((user) => (
                                <tr key={user.userId} id={user.userId}>
                                    <td className="text-dark-75 font-weight-bolder">{user.userId}</td>
                                    <td className="text-dark-50 font-weight-bold">{user.name}</td>
                                    <td className="text-dark-75 font-weight-bolder">{user.email}</td>
                                    <td className="text-dark-50 font-weight-bold">{user.roleTitle}</td>
                                    <td className="text-dark-75 font-weight-bolder">{user.status == "1" ? "Activo" : "Inactivo"}</td>
                                    <td className="text-dark-50 font-weight-bold">{user.created_at}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="d-flex justify-content-between">
                        <div className="col mt-2 px-0">
                            {lang.get('messages.mostrando_del')} {this.state.showFrom} {lang.get('messages.al')} {this.state.showTo} {lang.get('messages.de')} {this.state.totalUsers} {lang.get('messages.registros')}.
                        </div>
                        <div className="row">
                            <div className="d-flex justify-content-between">
                                <p className="mr-2 mt-2">
                                    {lang.get('messages.mostrar')}:
                                </p>
                                <select
                                    value={this.state.itemsPerPage}
                                    onChange={this.handleItemsPerPageChange}
                                    aria-controls="datatable"
                                    className="custom-select custom-select-sm form-control form-control-sm"
                                >
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                </select>
                            </div>
                            <ReactPaginate
                                previousLabel={'< ' + lang.get('messages.anterior')}  
                                nextLabel={ lang.get('messages.siguiente') + ' >'} 
                                breakLabel={'...'}
                                breakClassName={'break-me'}
                                pageCount={this.state.totalPages}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={this.handlePageClick}
                                containerClassName={'pagination'}
                                activeClassName={'active'}
                                previousClassName={'previous'}
                                nextClassName={'next'}
                                forcePage={this.state.currentPage}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
      );
    }
}

export default ReportsUsers;
